import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../lib/analytics';
import { useTrainingSession } from './session';
import { RegisterGate } from './RegisterGate';
import { CURRICULUM } from './curriculum';

export function TrainingCatalog() {
  const { persona, moduleProgress } = useTrainingSession();

  useEffect(() => {
    trackEvent('training_tab_opened', { from: 'catalog' });
  }, []);

  if (persona === 'anonymous') {
    return (
      <div className="tr-root">
        <div className="tr-wrap tr-appsec">
          <RegisterGate />
        </div>
      </div>
    );
  }

  const included = CURRICULUM.filter((m) => m.access === 'free' || persona !== 'free');
  const locked = CURRICULUM.filter((m) => m.access === 'pro' && persona === 'free');
  const module1Progress = moduleProgress['m1'];

  return (
    <div className="tr-root">
      <div className="tr-wrap tr-appsec">
        <h1 className="tr-h1">Security training</h1>
        <p className="tr-sub">
          Short, self-paced modules on how scams work and how to shut them
          down.
          {persona === 'free' && ' Module 1 is yours on the free plan.'}
        </p>

        {module1Progress && module1Progress.completedLessons < module1Progress.totalLessons && (
          <div className="tr-resume">
            <div className="tr-resume-t">
              <div className="tr-k">Pick up where you left off</div>
              <h3>Module 1 · How a scam actually works</h3>
              <div className="tr-bar">
                <i style={{ width: `${(module1Progress.completedLessons / module1Progress.totalLessons) * 100}%` }} />
              </div>
              <div className="tr-pct">
                {module1Progress.completedLessons} of {module1Progress.totalLessons} lessons done
              </div>
            </div>
            <Link className="tr-btn tr-btn-primary" to={`/training/module/m1/lesson/${module1Progress.completedLessons + 1}`}>
              Continue <i className="ti ti-arrow-right"></i>
            </Link>
          </div>
        )}

        {persona === 'free' && (
          <div className="tr-upsell">
            <i className="ti ti-lock"></i>
            <p>
              <b>Seven more modules with Pro.</b> Wire fraud, impersonation,
              AI voice scams, and what to do in the first 24 hours.
            </p>
            <Link
              className="tr-btn tr-btn-primary tr-btn-sm"
              to="/training/plans"
              onClick={() => trackEvent('upgrade_panel_viewed', { source: 'catalog' })}
            >
              See what's in Pro
            </Link>
          </div>
        )}

        <div className="tr-gt">{persona === 'free' ? 'Included with your plan' : 'Your curriculum'}</div>
        <div className="tr-cards">
          {included.map((m) => {
            const progress = moduleProgress[m.id];
            const badge = progress
              ? progress.completedLessons === progress.totalLessons
                ? null
                : <span className="tr-badge tr-badge-prog">In progress</span>
              : null;
            return (
              <Link className="tr-card" to={`/training/module/${m.id}`} key={m.id}>
                <div className="tr-thumb"><i className="ti ti-school"></i></div>
                <div className="tr-card-b">
                  <div className="tr-card-top">
                    <h3>{m.title}</h3>
                    {badge}
                  </div>
                  <p>{m.description}</p>
                  <div className="tr-card-meta">
                    <span><i className="ti ti-clock"></i>{m.durationLabel}</span>
                    <span><i className="ti ti-book"></i>{m.lessons.length} lessons</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        {locked.length > 0 && (
          <>
            <div className="tr-gt">Unlocks with Pro</div>
            <div className="tr-cards">
              {locked.map((m) => (
                <Link
                  className="tr-card"
                  to={`/training/module/${m.id}`}
                  key={m.id}
                  onClick={() => trackEvent('locked_module_viewed', { module_id: m.id, from: 'catalog' })}
                >
                  <div className="tr-thumb tr-lk"><i className="ti ti-lock"></i></div>
                  <div className="tr-card-b">
                    <div className="tr-card-top">
                      <h3>{m.title}</h3>
                      <span className="tr-badge tr-badge-pro">Pro</span>
                    </div>
                    <p>{m.description}</p>
                    <div className="tr-card-meta">
                      <span><i className="ti ti-clock"></i>{m.durationLabel}</span>
                      <span><i className="ti ti-book"></i>{m.lessons.length} lessons</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
